/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {LocationInstance} from "../../../models/location-instance";

export class LocationUi {
  mLocation: LocationInstance;
  mImage: createjs.Bitmap;

  setLocation(location: LocationInstance): LocationUi {
    this.mLocation = location;
    return this;
  }
}
